import { Component, computed, effect, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlayerComponent } from '../../components/player/player.component';
import { PlaylistComponent } from '../../components/playlist/playlist.component';
import { ToasterService } from './../../components/toaster/toaster.service';
import { PlaylistService } from '../../services/playlist.service';
import { PlayerService } from '../../services/player.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { ButtonModule } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'dev',
  imports: [
    CommonModule,
    PlayerComponent,
    PlaylistComponent,
    ButtonModule,
    RouterLink,
  ],
  templateUrl: './dev.component.html',
  styleUrl: './dev.component.scss',
})
export class DevComponent {
  toaster = inject(ToasterService);
  playlistService = inject(PlaylistService);
  playerService = inject(PlayerService);
  user = inject(UserService);
  playlistPosition = signal<number>(0);

  title = computed(() => this.playlistService.nowPlaying().title);
  username = computed(() => this.user.getCurrentUser());

  constructor() {
    effect(() => {
      const nowPlaying = this.playlistService.nowPlaying();
      this.playlistPosition.set(nowPlaying.position);
    });
  }

  showToast() {
    this.toaster.testToast();
  }

  async seekToEnd() {
    try {
      await this.playerService.seekToEnd();
    } catch (err) {
      console.error('❌ Failed to seek to end:', err);
    }
  }

  removeLoggedInUser() {
    this.user.removeUserData();
  }

  setPlaylistPosition(value: number) {
    this.playlistService.setPlaylistPosition(value);
  }
}
